import { ReportData } from '../types/reportTypes';

// Cody Cline Direct Sales May 2026 Data
// IMPORTANT: Using 13% flat OH calculation (Contract Total × 0.13)
// Source CSV: sample csv/2025 TLLG Marketing Leads Report - Cody - Sales May26.csv
// 14 valid jobs; trailing blank rows (21-37) and Totals row (38) excluded per processing rules.
// Sum-of-rows used per Rule 1 (CSV Totals row GP $205,994.31 vs sum $205,994.32 — $0.01 rounding).
const jobData = [
  {
    jobInfo: "E-1016: The Enclave At Ellicott Hills",
    leadSource: "Referral- Dominic's network",
    trade: "Solar",
    contractTotal: 1772.00,
    grossMarginPct: 0.4498,
    grossProfit: 797.05,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1772.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1018: Dr. Leonard Leo",
    leadSource: "Referral- Dominic's network",
    trade: "Painting & Others",
    contractTotal: 3475.00,
    grossMarginPct: 0.4826,
    grossProfit: 1677.04,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3475.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1047: Rhonda Cohen",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 18390.00,
    grossMarginPct: 0.4120,
    grossProfit: 7576.68,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 18390.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1017: Ellicott Hills Condo 1",
    leadSource: "Referral- Dominic's network",
    trade: "Solar",
    contractTotal: 1181.00,
    grossMarginPct: 0.4496,
    grossProfit: 530.98,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1181.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1028: Pennrose Management Pointe View",
    leadSource: "Referral- Cody's network",
    trade: "Painting & Others",
    contractTotal: 4390.00,
    grossMarginPct: 0.5444,
    grossProfit: 2389.92,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 4390.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1014: Katherine Leigey",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 1649.00,
    grossMarginPct: 0.4525,
    grossProfit: 746.17,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1649.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1033: Tabor Lynch Project (windows only from E-823)",
    leadSource: "Referral- Cody's network",
    trade: "Windows & Doors",
    contractTotal: 3281.00,
    grossMarginPct: 0.5459,
    grossProfit: 1791.10,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3281.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1026: Nicole Valerio",
    leadSource: "Referral- Cody's network",
    trade: "Windows & Doors",
    contractTotal: 49069.70,
    grossMarginPct: 0.3646,
    grossProfit: 17890.81,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 49069.70 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1012: North Green Condominium Association",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 121920.14,
    grossMarginPct: 0.6067,
    grossProfit: 73968.95,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 121920.14 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1077: Megan and Robert Supinski",
    leadSource: "Referral- Cody's network",
    trade: "Painting & Others",
    contractTotal: 73552.60,
    grossMarginPct: 0.5724,
    grossProfit: 42101.51,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 73552.60 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1073: Solution based Property management",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 603.00,
    grossMarginPct: 0.3000,
    grossProfit: 180.90,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 603.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1044: Aion Management Harborclub",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 90765.00,
    grossMarginPct: 0.4268,
    grossProfit: 38738.50,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 90765.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1064: Martha Lester",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 1827.00,
    grossMarginPct: 0.4400,
    grossProfit: 803.88,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1827.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1046: Anthony Guadagni",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 44910.00,
    grossMarginPct: 0.3741,
    grossProfit: 16800.83,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 44910.00 * 0.13,
    netProfit: 0
  }
];

// Apply Cody Cline calculation formula
// Net Profit = Gross Profit - Company OH
// Sales Commission = Net Profit ÷ 2 (50% of Net Profit)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - job.companyOH;
  job.salesCommission = job.netProfit / 2;
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

export const codySalesMay2026Data: ReportData = {
  kpis: {
    adSpend: 0,
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: 0,
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: [
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 }
  ],

  salesBySource: salesBySource,

  salesByTrade: salesByTrade,

  jobData: jobData,

  period: {
    month: 5,
    year: 2026
  }
};
